export const getLocation = (data, key) => {
	const locations = data?.content?.locations || {};
	const locationKey = key || Object.keys(locations).find((k) => locations[k]?.default?.value === 'true');

	const location = {
		locationKey,
		...locations[locationKey]?.['Location']?.value,
		...locations[locationKey],
	};
	return location;
};
